"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var DeveloperToolbar_1 = __importDefault(require("../DeveloperToolbar"));
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var react_i18next_1 = require("react-i18next");
var inertia_1 = require("@inertiajs/inertia");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_2 = require("@fortawesome/free-solid-svg-icons");
var IntegrationEditor_module_css_1 = __importDefault(require("./IntegrationEditor.module.css"));
var IntegrationTemplateInfoTab_1 = __importDefault(require("./IntegrationTemplateInfoTab"));
var AjaxProvider_1 = __importDefault(require("@/functions/AjaxProvider"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var IntegrationTemplateEditor = function (_a) {
    var integrationTemplateData = _a.integrationTemplateData;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = (0, react_1.useState)("Info"), activeTab = _b[0], setActiveTab = _b[1];
    var logger = q_play_core_1.logManager.getLogger();
    var _c = (0, react_1.useState)(integrationTemplateData), localTemplateData = _c[0], setLocalTemplateData = _c[1];
    var tabs = [
        { name: "Info", icon: free_solid_svg_icons_1.faInfoCircle, dataCy: "infoTab" },
        { name: "Settings", icon: free_solid_svg_icons_1.faCog, dataCy: "settingsTab" },
        { name: "Script", icon: free_solid_svg_icons_1.faCode, dataCy: "scriptTab" },
    ];
    var handleBack = function () {
        inertia_1.Inertia.visit("/developer");
    };
    var handleTabChange = function (nextTab) {
        setActiveTab(nextTab);
    };
    var saveTemplateInfo = function (name, description, descriptionLink, setupQuickGuide, isPublic, isVisible) { return __awaiter(void 0, void 0, void 0, function () {
        var dataProvider, resource, payload, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dataProvider = (0, AjaxProvider_1.default)("/api");
                    resource = "integration-templates/update/".concat(localTemplateData.id);
                    payload = {
                        name: name,
                        description: description,
                        description_link: descriptionLink,
                        setup_quick_guide: setupQuickGuide,
                        public: isPublic,
                        visible: isVisible,
                    };
                    return [4 /*yield*/, dataProvider.update(resource, {
                            id: "",
                            data: payload,
                            previousData: {},
                        })];
                case 1:
                    _a.sent();
                    setLocalTemplateData(function (prev) { return (__assign(__assign({}, prev), { name: name, description: description, description_link: descriptionLink, setup_quick_guide: setupQuickGuide, public: isPublic, visible: isVisible })); });
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    logger.error("Error updating integration template info:", error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", { className: "template-editor" },
        react_1.default.createElement("div", { className: IntegrationEditor_module_css_1.default["toolbar-area"] },
            react_1.default.createElement("div", { className: IntegrationEditor_module_css_1.default["back-button"], onClick: handleBack, title: t("Back to developer page") },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_2.faArrowLeft, style: { marginRight: "8px" } })),
            react_1.default.createElement("div", { className: IntegrationEditor_module_css_1.default["toolbar-center"] },
                react_1.default.createElement(DeveloperToolbar_1.default, { tabs: tabs, activeTab: activeTab, onTabChange: handleTabChange }),
                react_1.default.createElement("div", { className: IntegrationEditor_module_css_1.default["template-save-button-container"] })),
            react_1.default.createElement("div", { className: IntegrationEditor_module_css_1.default["toolbar-right"] })),
        activeTab === "Info" && (react_1.default.createElement(IntegrationTemplateInfoTab_1.default, { integrationTemplateData: localTemplateData, onSave: saveTemplateInfo })),
        activeTab === "Settings" && (react_1.default.createElement("div", null, "Settings Coming Soon")),
        activeTab === "Script" && (react_1.default.createElement("div", null, "Script Editor Coming Soon"))));
};
exports.default = IntegrationTemplateEditor;
